import { useGenUiConfig } from '../../shared/ui/config.js';
import type { MobilityPlacesPort } from '@voll-intelligence/genui-contract';

export type { MobilityPlacesPort } from '@voll-intelligence/genui-contract';

/** O port de lugares do card `mobility_planner`; ausente ⇒ `null` (a busca fica vazia). */
export function useMobilityPlacesPort(): MobilityPlacesPort | null {
  return useGenUiConfig().ports?.mobilityPlaces ?? null;
}
